import React, { useLayoutEffect, useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/img/logo-royal-blue.png";

function Head(props) {
  const [menuOn, setmenuOn] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const listener = () => setScroll(window.scrollY > 110);
    window.addEventListener("scroll", listener);
    return () => window.removeEventListener("scroll", listener);
  }, []);

  function useWindowSize() {
    const [size, setSize] = useState();
    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  const width = useWindowSize();

  function logoutHandler() {
    try {
      localStorage.removeItem("authToken");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("visitorToken");
    } catch (err) {
      console.log(err);
    }
  }

  let child = null;

  if (localStorage.getItem("authToken"))
    child = (
      <>
        <div className="col-xl-6 col-sm-1 col-2 text-center">
          <div className="primary-menu">
            <div className={`nav-menu ${menuOn ? "menu-on" : ""}`}>
              <div
                className="navbar-close"
                onClick={() => {
                  setmenuOn(!menuOn);
                }}>
                <div className="cross-wrap">
                  <span className="top"></span>
                  <span className="bottom"></span>
                </div>
              </div>
              <nav className="main-menu">
                <ul className="flex-nowrap">
                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/dashboard">
                      Dashboard
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/profile">
                      Profile
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/transactions">
                      Transactions
                    </NavLink>
                  </li>

                  {width < 1199 ? (
                    <li className="menu-item ">
                      <NavLink className="nav-link" onClick={() => logoutHandler()} to="/login">
                        Logout
                      </NavLink>
                    </li>
                  ) : null}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 col-5">
          <div className="header-right">
            <ul>
              {width > 1199 ? (
                <li className="menu-item get-started-wrapper">
                  <Link onClick={() => logoutHandler()} to="/login" className="filled-btn bg-clear-blue">
                    Logout
                  </Link>
                </li>
              ) : null}
              <li>
                <div className="menu-toggle">
                  <div className="menu-overlay"></div>
                  <div className="nav-toggle">
                    <div
                      className={`navbar-toggler float-end ${menuOn ? "active" : ""}`}
                      onClick={() => {
                        setmenuOn(!menuOn);
                      }}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  else if (localStorage.getItem("visitorToken"))
    child = (
      <>
        <div className="col-xl-6 col-sm-1 col-2 text-center">
          <div className="primary-menu">
            <div className={`nav-menu ${menuOn ? "menu-on" : ""}`}>
              <div
                className="navbar-close"
                onClick={() => {
                  setmenuOn(!menuOn);
                }}>
                <div className="cross-wrap">
                  <span className="top"></span>
                  <span className="bottom"></span>
                </div>
              </div>
              <nav className="main-menu">
                <ul className="flex-nowrap">
                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/visitordashboard">
                      Dashboard
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/visitorprofile">
                      Profile
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/addcityrates">
                      City Rates
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/pastvisits">
                      Past Visits
                    </NavLink>
                  </li>

                  {width < 1199 ? (
                    <li className="menu-item ">
                      <NavLink className="nav-link" onClick={() => logoutHandler()} to="/visitorlogin">
                        Logout
                      </NavLink>
                    </li>
                  ) : null}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 col-5">
          <div className="header-right">
            <ul>
              {width > 1199 ? (
                <li className="menu-item get-started-wrapper">
                  <Link onClick={() => logoutHandler()} to="/visitorlogin" className="filled-btn bg-clear-blue">
                    Logout
                  </Link>
                </li>
              ) : null}
              <li>
                <div className="menu-toggle">
                  <div className="menu-overlay"></div>
                  <div className="nav-toggle">
                    <div
                      className={`navbar-toggler float-end ${menuOn ? "active" : ""}`}
                      onClick={() => {
                        setmenuOn(!menuOn);
                      }}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  else if (localStorage.getItem("adminToken"))
    child = (
      <>
        <div className="col-xl-6 col-sm-1 col-2 text-center">
          <div className="primary-menu">
            <div className={`nav-menu ${menuOn ? "menu-on" : ""}`}>
              <div
                className="navbar-close"
                onClick={() => {
                  setmenuOn(!menuOn);
                }}>
                <div className="cross-wrap">
                  <span className="top"></span>
                  <span className="bottom"></span>
                </div>
              </div>
              <nav className="main-menu">
                <ul className="flex-nowrap">
                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/admindashboard">
                      Dashboard
                    </NavLink>
                  </li>

                  <li className="menu-item menu-item-has-children">
                    <a href="##">Users</a>
                    <ul className="sub-menu">
                      <li>
                        <NavLink aria-current="page" to="/users">
                          Customers
                        </NavLink>
                      </li>

                      <li>
                        <NavLink aria-current="page" to="/admins">
                          Admins
                        </NavLink>
                      </li>

                      <li>
                        <NavLink aria-current="page" to="/visitors">
                          Visitors
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li className="menu-item menu-item-has-children">
                    <a href="##">Payment</a>
                    <ul className="sub-menu">
                      <li>
                        <NavLink aria-current="page" to="/visitpayment">
                          Visit Payment
                        </NavLink>
                      </li>
                      <li>
                        <NavLink aria-current="page" to="/admintransactions">
                          Transactions
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li className="menu-item menu-item-has-children">
                    <a href="##">Misc</a>
                    <ul className="sub-menu">
                      <li>
                        <NavLink aria-current="page" to="/adminprofile">
                          Profile
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li className="menu-item menu-item-has-children">
                    <a href="##">Leads</a>
                    <ul className="sub-menu">
                      <li>
                        <NavLink aria-current="page" to="/leads">
                          Front Leads
                        </NavLink>
                      </li>
                      <li>
                        <NavLink aria-current="page" to="/moreleads">
                          Back Leads
                        </NavLink>
                      </li>
                      <li>
                        <NavLink aria-current="page" to="/addmoreleads">
                          Add Back Leads
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  {width < 1199 ? (
                    <li className="menu-item ">
                      <NavLink className="nav-link" onClick={() => logoutHandler()} to="/adminlogin">
                        Logout
                      </NavLink>
                    </li>
                  ) : null}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 col-5">
          <div className="header-right">
            <ul>
              {width > 1199 ? (
                <li className="menu-item get-started-wrapper">
                  <Link onClick={() => logoutHandler()} to="/adminlogin" className="filled-btn bg-clear-blue">
                    Logout
                  </Link>
                </li>
              ) : null}
              <li>
                <div className="menu-toggle">
                  <div className="menu-overlay"></div>
                  <div className="nav-toggle">
                    <div
                      className={`navbar-toggler float-end ${menuOn ? "active" : ""}`}
                      onClick={() => {
                        setmenuOn(!menuOn);
                      }}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  else
    child = (
      <>
        <div className="col-xl-6 col-sm-1 col-2 text-center">
          <div className="primary-menu">
            <div className={`nav-menu ${menuOn ? "menu-on" : ""}`}>
              <div
                className="navbar-close"
                onClick={() => {
                  setmenuOn(!menuOn);
                }}>
                <div className="cross-wrap">
                  <span className="top"></span>
                  <span className="bottom"></span>
                </div>
              </div>
              <nav className="main-menu">
                <ul className="flex-nowrap ">
                  <li className="menu-item ">
                    <NavLink exact className="nav-link" activeClassName="active" aria-current="page" to="/">
                      Home
                    </NavLink>
                  </li>
                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/pricing">
                      Pricing
                    </NavLink>
                  </li>

                  <li className="menu-item ">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/faq">
                      FAQ
                    </NavLink>
                  </li>
                  <li className="menu-item">
                    <NavLink className="nav-link " aria-current="page" activeClassName="active" to="/login">
                      Login
                    </NavLink>
                  </li>
                  <li className="menu-item ">
                    <NavLink className="nav-link" aria-current="page" activeClassName="active" to="/register">
                      Register
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 col-5">
          <div className="header-right">
            <ul>
              <li className="get-started-wrapper">
                <Link to="/register" className="filled-btn bg-clear-blue">
                  Get Started <i className="fas fa-sign-in"></i>
                </Link>
              </li>
              <li>
                <div className="menu-toggle">
                  <div className="menu-overlay"></div>
                  <div className="nav-toggle">
                    <div
                      className={`navbar-toggler float-end ${menuOn ? "active" : ""}`}
                      onClick={() => {
                        setmenuOn(!menuOn);
                      }}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </>
    );

  return (
    <div>
      <header className="header-area header-v1">
        <div className={`header-navigation ${scroll ? "sticky" : ""} ${width < 1199 ? "breakpoint-on" : ""}`}>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xl-2 col-sm-5 col-5">
                <div className="site-branding-and-language-selection">
                  <div className="brand-logo">
                    <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/">
                      <img src={logo} alt="logo" />
                    </NavLink>
                  </div>
                </div>
              </div>
              {child}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Head;
